import { isDefinedAndNotNull } from './isDefinedAndNotNull.js';
export const getCloudinaryUrl = ({ path: path_raw, aspect_ratio, width, height, }) => {
    const path = path_raw.startsWith('/') ? path_raw : `/${path_raw}`;
    let transformations1 = ['b_auto:predominant_gradient:4', 'c_mpad'];
    if (isDefinedAndNotNull(aspect_ratio)) {
        transformations1.push(`ar_${aspect_ratio.toFixed(2)}`);
    }
    transformations1 = transformations1.concat(['e_improve', 'f_auto', 'q_auto']);
    const transformations2 = [];
    if (isDefinedAndNotNull(width)) {
        transformations2.push(`w_${width}`);
        if (!transformations2.includes('c_scale')) {
            transformations2.push('c_scale');
        }
    }
    if (isDefinedAndNotNull(height)) {
        transformations2.push(`h_${height}`);
        if (!transformations2.includes('c_scale')) {
            transformations2.push('c_scale');
        }
    }
    if (transformations1.length > 0) {
        if (transformations2.length > 0) {
            return new URL(`/pendwa/image/upload/${transformations1.join(',')}/${transformations2.join(',')}${path}`, `https://res.cloudinary.com`).href;
        }
        else {
            return new URL(`/pendwa/image/upload/${transformations1.join(',')}${path}`, `https://res.cloudinary.com`).href;
        }
    }
    else {
        return new URL(`/pendwa/image/upload${path}`, `https://res.cloudinary.com`).href;
    }
};
//# sourceMappingURL=getCloudImageUrl.js.map